import { defineComponent as _defineComponent } from 'vue'
import HistoryItemSkill from '@/components/formats/ShokurekishoParts/HistoryItemSkill.vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoHistories } from '@/composables/format-edit/useShokurekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoSkillsCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const {
  activeHistoryItem,
  addSkillHistory,
  deleteSkillHistory,
  moveSkillHistory,
  activateHistoryItem
} = useProvidedShokurekishoHistories()

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, addSkillHistory, deleteSkillHistory, moveSkillHistory, activateHistoryItem, HistoryItemSkill }
}

})